// Ported from case-desk src/lib/performance.ts (commit 1d18e32) per docs/architecture/das-web.md § 14
// on 2026-08-18: User Timing from app start until the workspace is usable, and per navigation, so the
// end-to-end budget of das-web § 11 can be measured in E2E runs and correlated with the API.
const appStartMark = 'das-web:app-start';
const bootstrapUsableMeasure = 'das-web:bootstrap-usable';
const navigationMarkPrefix = 'das-web:navigation:';

function supportsUserTiming() {
  return typeof performance !== 'undefined' && 'mark' in performance && 'measure' in performance;
}

export function markAppStart() {
  if (!supportsUserTiming()) {
    return;
  }

  performance.clearMarks(appStartMark);
  performance.clearMeasures(bootstrapUsableMeasure);
  performance.mark(appStartMark);
}

export function markBootstrapUsable() {
  if (!supportsUserTiming() || performance.getEntriesByName(appStartMark, 'mark').length === 0) {
    return;
  }

  performance.clearMeasures(bootstrapUsableMeasure);
  performance.measure(bootstrapUsableMeasure, appStartMark);
}

/** Marks the start of a warm navigation to a view; `measureNavigationUsable` closes it. */
export function markNavigationStart(view: string) {
  if (!supportsUserTiming()) {
    return;
  }

  performance.mark(`${navigationMarkPrefix}${view}:start`);
}

export function measureNavigationUsable(view: string) {
  if (!supportsUserTiming()) {
    return;
  }

  const startName = `${navigationMarkPrefix}${view}:start`;
  if (performance.getEntriesByName(startName, 'mark').length === 0) {
    return;
  }

  performance.measure(`${navigationMarkPrefix}${view}:usable`, startName);
  performance.clearMarks(startName);
}
